import React, { Fragment, memo } from 'react';
import MUIDataTable from 'mui-datatables';
import { Chip, IconButton, Tooltip} from '@material-ui/core';
import AddIcon from "@material-ui/icons/Add";
import ActiveUserCell from './ActiveUserCell';
import EditRolesCell from './EditRolesCell';
import LockedUserCell from './LockedUserCell';
import { formatDate, humanizeSnakeCaseString } from '../../utils/formatters';

// TODO: Allow filtering by roles. Need custom filtering or rendering logic
const getColumns = (rolesData) => [
    {
        name: 'ID',
        options: {
            filter: false,
            display: false,
        }
    },
    {
        name: 'Name',
        options: {
            filter: false,
        }
    },
    {
        name: 'Email',
        options: {
            filter: false
        }
    },
    {
        name: 'Roles',
        options: {
            customBodyRender: (value) => {
                return value.map(role => {
                    return <Chip key={role} label={humanizeSnakeCaseString(role)} style={{ margin: '5px' }} />
                });
            }
        }
    },
    {
        name: 'Edit Roles',
        options: {
            customBodyRender: (value, tableMeta) => {
                return <EditRolesCell id={tableMeta.rowData[0]} email_address={tableMeta.rowData[2]} currentRoles={tableMeta.rowData[3]} rolesData={rolesData} />
            }
        }
    },
    {
        name: 'Active User?',
        options: {
            customBodyRender: (value, tableMeta) => {
                return <ActiveUserCell id={tableMeta.rowData[0]} email_address={tableMeta.rowData[1]} value={value} />
            }
        }
    },
    {
        name: 'Locked',
        options: {
            customBodyRender: (value, tableMeta) => {
                return <LockedUserCell id={tableMeta.rowData[0]} value={value} />
            }
        }
    },
    {
        name: 'Created Date',
        options: {
            filter: false
        }
    },
];

const getTableOptions = (toggleShowNewUser) => {
    return {
        filterType: 'dropdown',
        selectableRows: 'none',
        print: false,
        download: false,
        expandableRowsHeader: false,
        customToolbar: () => {
            return (
                <AddUserToolbarButton toggleShowNewUser={toggleShowNewUser} />
            );
        }
    };
};


const tablifyUsers = users =>
    users === null ? null :
users.map(user => {
    return [
        user.id,
        user.firstName + " " + user.lastName,
        user.emailAddress,
        (user.roles || []).sort(),
        null,
        user.active,
        Boolean(user.lockedAt),
        formatDate(user.createdAt),
    ];
});

const AddUserToolbarButton = ({toggleShowNewUser}) => {
    const handleAddUserClick = () => {
        toggleShowNewUser();
    }

    return (
        <Fragment>
            <Tooltip title={"Add New User"}>
                <IconButton onClick={handleAddUserClick}>
                    <AddIcon />
                </IconButton>
            </Tooltip>
        </Fragment>
    );
}

const UserAdminTable = ({users, roles, toggleShowNewUser}) => {
    const options = getTableOptions(toggleShowNewUser);

    return users == null ? (
        <h1>Loading...</h1>
    ) : (
        <MUIDataTable data={tablifyUsers(users)} columns={getColumns(roles)} options={options} />
    );
}

export default memo(UserAdminTable);